import { model, tProp, types } from 'mobx-keystone'
import { ApiModel } from '~api/model/ApiModel'

@model('Navigation')
export class Navigation extends ApiModel({
	id: tProp(types.maybe(types.number)),
	key: tProp(types.string)
}) {}
